import { Dashboard } from "../../dashboard/dashboard";

export class responseGetDashboard {
    list:Array<Dashboard>;
    constructor(data) {
        this.list = data.map(item => new Dashboard(item));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-dashboard.ts